import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import { useBlog } from '../../context/BlogContext';
import AdminBlogSidebar from '../../components/adminblog/AdminBlogSidebar';
import '../../styles/AdminBlog.css';

export default function AdminBlogSettings() {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAdmin();
  const { settings, updateSettings, categories, addCategory, deleteCategory } = useBlog();
  const [localSettings, setLocalSettings] = useState(settings);
  const [newCatName, setNewCatName] = useState('');
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (!loading && !isAuthenticated) navigate('/adminblog');
  }, [isAuthenticated, loading, navigate]);

  useEffect(() => {
    setLocalSettings(settings);
  }, [settings]);

  const handleSave = async () => {
    try {
      await updateSettings(localSettings);
      setMessage({ type: 'success', text: 'Settings saved' });
    } catch (e) {
      setMessage({ type: 'error', text: 'No se pudo guardar. ¿Sesión caducada?' });
    }
    setTimeout(() => setMessage(null), 3000);
  };

  const handleAddCategory = async () => {
    if (!newCatName.trim()) return;
    try {
      await addCategory({ name: newCatName.trim(), description: '', color: '#5B7A94' });
      setNewCatName('');
    } catch (e) {
      setMessage({ type: 'error', text: 'No se pudo crear la categoría.' });
    }
  };

  if (loading) return <div className="adminblog-loading">Loading...</div>;

  return (
    <div className="adminblog-page">
      <header className="adminblog-header">
        <div className="adminblog-header-left">
          <div className="adminblog-header-title">
            <h1>Blog Admin</h1>
          </div>
        </div>
        <div className="adminblog-header-right">
          <button className="adminblog-save-btn" onClick={handleSave}>Save Settings</button>
        </div>
      </header>

      <div className="adminblog-layout">
        <AdminBlogSidebar />
        <main className="adminblog-main">
          <div className="adminblog-content">
            <div className="adminblog-page-header">
              <h2>Blog Settings</h2>
            </div>

            {message && <div className={`adminblog-message ${message.type}`}>{message.text}</div>}

            <div className="adminblog-settings-form">
              <h3>General</h3>
              <div className="adminblog-settings-section">
                <div className="adminblog-field">
                  <label>Blog Title</label>
                  <input
                    type="text"
                    value={localSettings.blogTitle || ''}
                    onChange={(e) => setLocalSettings({ ...localSettings, blogTitle: e.target.value })}
                  />
                </div>
                <div className="adminblog-field">
                  <label>Blog Subtitle</label>
                  <input
                    type="text"
                    value={localSettings.blogSubtitle || ''}
                    onChange={(e) => setLocalSettings({ ...localSettings, blogSubtitle: e.target.value })}
                  />
                </div>
                <div className="adminblog-field">
                  <label>Posts Per Page</label>
                  <input
                    type="number"
                    value={localSettings.postsPerPage || 12}
                    onChange={(e) => setLocalSettings({ ...localSettings, postsPerPage: parseInt(e.target.value) || 12 })}
                  />
                </div>
              </div>
            </div>

            <div className="adminblog-settings-form" style={{ marginTop: 24 }}>
              <h3>Categories</h3>
              <div className="adminblog-settings-section">
                <div className="adminblog-categories-list">
                  {categories.map(cat => (
                    <div key={cat.id} className="adminblog-category-item">
                      <span className="adminblog-category-color" style={{ background: cat.color }} />
                      <span className="adminblog-category-name">{cat.name}</span>
                      <span style={{ fontSize: 12, color: '#999' }}>{cat.slug}</span>
                      <button className="adminblog-category-delete" onClick={() => deleteCategory(cat.id)}>×</button>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input
                    type="text"
                    value={newCatName}
                    onChange={(e) => setNewCatName(e.target.value)}
                    placeholder="New category name"
                    onKeyDown={(e) => e.key === 'Enter' && handleAddCategory()}
                    style={{ flex: 1, padding: '10px 12px', border: '1px solid #e5e5e5', borderRadius: 6, fontSize: 13 }}
                  />
                  <button
                    onClick={handleAddCategory}
                    style={{ padding: '10px 16px', background: '#333', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>

            <div className="adminblog-settings-form" style={{ marginTop: 24 }}>
              <h3>Default Hero Config</h3>
              <div className="adminblog-settings-section">
                <div className="adminblog-field">
                  <label>
                    <input
                      type="checkbox"
                      checked={localSettings.defaultHeroConfig?.autoplay || false}
                      onChange={(e) => setLocalSettings({
                        ...localSettings,
                        defaultHeroConfig: { ...localSettings.defaultHeroConfig, autoplay: e.target.checked },
                      })}
                      style={{ marginRight: 8 }}
                    />
                    Autoplay by default
                  </label>
                </div>
                <div className="adminblog-field">
                  <label>Default Delay (ms)</label>
                  <input
                    type="number"
                    value={localSettings.defaultHeroConfig?.autoplayDelay || 5000}
                    onChange={(e) => setLocalSettings({
                      ...localSettings,
                      defaultHeroConfig: { ...localSettings.defaultHeroConfig, autoplayDelay: parseInt(e.target.value) || 5000 },
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
